// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'



import 'lib-flexible'

Vue.config.productionTip = false

import { Swipe, SwipeItem } from 'vue-swipe' // 加这里

Vue.component('swipe', Swipe) // 加这里
Vue.component('swipe-item', SwipeItem) // 加这里


import MintUI from 'mint-ui'

import 'mint-ui/lib/style.css'
Vue.use(MintUI)
    /* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})

router.afterEach((to, from, next) => {             window.scrollTo(0, 0);          });


// WEBPACK FOOTER //
// ./src/main.js